
<div class="w-full flex flex-row  justify-center">
  <div *ngFor="let item of tabList" >
    <button mat-button [ngClass]="buttonSelect === item ? 'buttonSelected' : 'notButtonSelected' " 
    (click)="tabSelected.emit(item); buttonSelect =item " [attr.data-test-serenity-tab]="item" >{{utils.traslatei18n(item) | uppercase }}</button>
  </div>
</div>
